import { Warehouse } from 'src/app/shared/types/warehouse.model';
import { DateRange } from './dateRange';
import { PaginationFilters } from './paginationFilters';
import { Photographer } from './photographer';
import { Shot } from './shot';
import { Status } from './status';
import { Color, SizeGroup, Style } from './style';

export class OrderDetail {
	style?: Style;
	colorShots?: ColorShots[];
	warehouse?: Warehouse;

	constructor(init?: Partial<OrderDetail>) {
		Object.assign(this, init);
	}
}

export class ColorShots {
	color?: Color;
	shots?: Shot[];
	orderStyleId?: number;
	isAi?: boolean;

	constructor(init?: Partial<ColorShots>) {
		Object.assign(this, init);
	}
}

export class Waybill {
	waybillNumber?: string;
	waybillUrl?: string;
	shippingDate?: Date;
	constructor(init?: Partial<Waybill>) {
		Object.assign(this, init);
	}
}

export class Order {
	photographer?: Photographer;
	id?: number;
	/** Id ordine interno BasicNet, assegnato al primo invio ad AS400 (assente finché l'ordine non è trasmesso). */
	basicNetId?: number;
	orderType?: OrderTypeEnum;
	finalCost?: number;
	//estimatedCost?: number;
	totalOrdered?: number;
	totalShipped?: number;
	status?: Status;
	dueDate?: Date;
	creationDate?: Date;
	completionDate?: Date;
	notes?: string;
	warehouse?: Warehouse;
	waybill?: Waybill;
	isFake?: boolean;

	constructor(init?: Partial<Order>) {
		Object.assign(this, init);
	}
}

export enum OrderTypeEnum {
	Complete = 1,
	Dressed = 2,
	StillLife = 3
}

export class OrderType {
	id?: OrderTypeEnum;
	name?: string;

	constructor(init?: Partial<OrderType>) {
		Object.assign(this, init);
	}
}

/*export enum OrderStatus {
	Draft = 1,
	Submitted = 2,
	InProgress = 3,
	ShootCompleted = 4,
	Approved = 5,
	Rejected = 6
}*/

export enum OrderStatus {
	Draft = 1,
	Submitted = 2,
	ReadyForPickup = 3,
	InProgress = 4,
	ShootCompleted = 5,
	Approved = 6,
	Rejected = 7
}

export class OrderFilters extends PaginationFilters {
	ids?: number[];
	photographers?: Photographer[];
	dueDate?: DateRange;
	creationDate?: DateRange;
	completionDate?: DateRange;
	statuses?: Status[];
	orderTypes?: OrderType[];
	warehouses?: Warehouse[];
	constructor(init?: Partial<OrderFilters>) {
		super(init);
		Object.assign(this, init);
	}
}

export class OrderValitation {
	dueDate: boolean = true;
	photographer: boolean = true;

	constructor(init?: Partial<OrderValitation>) {
		Object.assign(this, init);
	}
}
